import { render, staticRenderFns } from "./AppCheckboxCalendar.vue?vue&type=template&id=64402ad4&"
import script from "./AppCheckboxCalendar.vue?vue&type=script&lang=js&"
export * from "./AppCheckboxCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports